import type { OperationResult, Files } from "@/libs/api";
import { fetchOperation, fetchCounters } from "@/libs/api";
import router from "@/router";
import { defineStore } from "pinia";

export const useOperationStore = defineStore({
  id: "operation",
  state: () => ({
    operationData: null as OperationResult | null,
    fileData: undefined as Files | null | undefined,
    counterType: "HOME" as string,
  }),
  getters: {
    customData: (state) => {
      return state.operationData?.custom;
    },
    filesData: (state) => {
      return state.operationData?.files;
    },
    counterData: async (state) => {
      const counters = state.operationData?.counters ?? [];
      if (Array.isArray(counters)) {
        const counter = counters.filter(
          (counter: {
            type: string;
            position: string;
            name: string;
            limit: number;
            productCount: number;
            increment: boolean;
            id: string;
            positiveText: string;
            negativeText: string;
          }) => counter.position === state.counterType
        );

        if (counter && counter.length > 0 && state.operationData?._id) {
          const getCountData = await fetchCounters(
            state.operationData?._id,
            (counter[0] as { name: string }).name || ""
          );

          (getCountData as any).data = counter[0];

          if (getCountData.value && getCountData.value < 0) {
            getCountData.value = getCountData.value = 0;
          }

          return getCountData;
        } else {
          return null;
        }
      }
    },
    formsData: (state) => {
      const forms = state.operationData?.forms ?? [];
      if (Array.isArray(forms)) {
        return forms.filter(
          (form: {
            _id: string;
            type: string;
            lang: string;
            line_item: boolean;
          }) => form.type === "CREATE"
        );
      }
      return [];
    },
  },
  actions: {
    async getHomeCounter(id: string, name: string) {
      try {
        return (await fetchCounters(id, name)) ?? null;
      } catch (e) {
        console.error(e);
      }
    },
    async getOperation() {
      try {
        this.operationData = (await fetchOperation()) ?? null;
      } catch (e) {
        router.push({ name: "404" });
      }
    },
  },
});
